import Button from '@material-ui/core/Button';
import React from 'react';

function Auth0RegisterTab(props) {

	return (
		<div className="w-full">
			<Button className="w-full my-48" color="primary" variant="contained" >
				Log In/Sign Up with Auth0
			</Button>
		</div>
	);
}

export default Auth0RegisterTab;
